import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { captchaApiKey } from '../../config/apiUrl';

function Captcha({ setValue }) {
  return (
    <div>
      <ReCAPTCHA className={'captcha'} sitekey={captchaApiKey} onChange={(e) => setValue(e)} />
    </div>
  );
}

export default Captcha;
